import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto
} from '../../util/varios';
import { Mensaje } from '../mensajes';


 
import axios from 'axios';
import useTableFijo from '../useTableFijo';
import { AgregarCompromiso } from './modalAgregarCompromiso';
import { Dimmer } from '../spinner';


function TablaDetallesAprobaciones(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    let prue;

    if (props.devolverc === 1) {
        prue = [
            { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° Documento', textAlign: 'center' },
            { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },
            { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Motivo', textAlign: 'center' },
            { id: '14', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Opciones', textAlign: 'center' },
        ]
    } else {
        prue = [
            { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° Documento', textAlign: 'center' },
            { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },
            { id: '14', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Opciones', textAlign: 'center' },
        ]
    }

    const headCells = prue;

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const txtMonto = useRef([]);
    const txtMontoTotal = useRef();



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const handleCloseMensa = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        blanquearCampos();

        if (ope === 1) {

            setMostrar5(true);
            setOperacion(1);
            blanquearCampos()

        } if (ope === 3) {

        }

    }

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);

        console.log(datos);

        let data = [...records];


        for (let i = 0; i < datos.length; i++) {

            data.push({
                idordenpago: datos[i].idordencompra,
                concepto: datos[i].concepto,
                motivo: datos[i].motivodevol,
                idaprobacionesdetalle: 0,
                tipo: datos[i].tipo,
                val: datos[i].val,
                validaparam: datos[i].validaparam
            });

        }

        setRecords(data);
        props.data(data);
    }

    useEffect(() => {

        if (props.datarecords.length > 0) {

            var data = [...props.datarecords];
            var datos = [];

            for (let i = 0; i < data.length; i++) {

                datos.push({

                    idordenpago: data[i].idordenpago,
                    concepto: data[i].concepto,
                    motivo: data[i].motivo,
                    idaprobacionesdetalle: data[i].idaprobacionesdetalle,
                    tipo: data[i].tipo

                });

            }

            console.log(datos);
            setRecords(datos);
        }

    }, [props.datarecords]);

    const eliminarSolicitud = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.idordenpago !== datos[i].idordenpago) {
                elementos.push(datos[i]);
            }

        }
        
        setRecords(elementos);
        props.data(elementos);
    }

    return (
        <div>

            <AgregarCompromiso
                show={mostrar5}
                operacion={operacion}
                devolver={props.devolverc}
                ubica={props.ubi}
                tipocom={props.tipocom}
                tipo={1}
                retorno={records}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
            />
            
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>



            <div className="row col-md-12 mx-auto m-0">

                <div className="col-md-11 m-0 px-0 mb-1">
                    <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }}>
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idcuenta} className="table-bordered" style={{ padding: "0", height: '40px' }}>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "50px" }}>{item.idordenpago}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '350px' }}>{item.concepto}</td>
                                        {props.devolverc === 1 ?
                                        <td className='align-middle text-uppercase' style={{ fontSize: "10px", textAlign: "center", width: '350px' }}>{item.motivo}</td> : ''}
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "60px" }}>
                                            <button onClick={eliminarSolicitud(item)} disabled={props.operacion === 4 || props.operacion === 2 ? true : false} className="btn btn-danger btn-sm rounded-circle"><i className="fa fa-trash-alt"></i></button>
                                        </td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    {/* <TblPagination /> */}

                </div>
                <div className='col-md-1 m-auto mb-1'>

                    <div className="col-md-12">
                        <button onClick={opciones(1, '')} disabled={props.operacion === 4 || props.operacion === 2 ? true : false} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-plus"><small> INCLUIR</small></i> </button>
                    </div>

                </div>
            </div>


        </div>

    );

}

export default TablaDetallesAprobaciones;
